// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/device.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_api_gateway_v1_core } from "./core_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/device.proto.
 */
export const file_api_gateway_v1_device: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_gateway_v1_core, file_google_protobuf_timestamp]);

/**
 * Device message represents a physical device in the system.
 *
 * @generated from message gateway.v1.Device
 */
export type Device = Message<"gateway.v1.Device"> & {
  /**
   * uuid is the unique identifier for the device, generated as a UUID string.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name unic for the device (model prefix with incremental id).
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * type of the device (sensor or driver).
   *
   * @generated from field: gateway.v1.DeviceType type = 3;
   */
  type: DeviceType;

  /**
   * model of the device, which can be either a sensor model or a driver model depending on the device type.
   *
   * @generated from oneof gateway.v1.Device.device
   */
  device: {
    /**
     * sensor contains the specific details of a sensor device if the device type is sensor.
     *
     * @generated from field: gateway.v1.DeviceSensor sensor = 4;
     */
    value: DeviceSensor;
    case: "sensor";
  } | {
    /**
     * driver contains the specific details of a driver device if the device type is driver.
     *
     * @generated from field: gateway.v1.DeviceDriver driver = 5;
     */
    value: DeviceDriver;
    case: "driver";
  } | { case: undefined; value?: undefined };

  /**
   * tenant_uuid is the identifier for the tenant that owns this device, used for multi-tenancy support.
   *
   * @generated from field: string tenant_uuid = 6;
   */
  tenantUuid: string;

  /**
   * created_at timestamp when the device was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * updated_at timestamp when the device was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 0);

/**
 * DeviceSensor message represents the specific details of a sensor device.
 *
 * @generated from message gateway.v1.DeviceSensor
 */
export type DeviceSensor = Message<"gateway.v1.DeviceSensor"> & {
  /**
   * type of the sensor, which indicates the specific technology that it uses (e.g., ultrasonic, infrared, etc.).
   *
   * @generated from field: gateway.v1.DeviceSensorType type = 1;
   */
  type: DeviceSensorType;

  /**
   * sewer_location of the sensor, which indicates where the sensor is placed on the installation (e.g., public sewer, private sewer, etc.).
   *
   * @generated from field: gateway.v1.DeviceSensorSewerLocation sewer_location = 2;
   */
  sewerLocation: DeviceSensorSewerLocation;

  /**
   * model of the sensor, exact model bought by the customer (e.g., US100, HC-SR04, etc.).
   *
   * @generated from oneof gateway.v1.DeviceSensor.model
   */
  model: {
    /**
     * ultrasonic_model specifies the model of the ultrasonic sensor if the sensor type is ultrasonic.
     *
     * @generated from field: gateway.v1.DeviceSensorUltrasonicModel ultrasonic_model = 3;
     */
    value: DeviceSensorUltrasonicModel;
    case: "ultrasonicModel";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gateway.v1.DeviceSensor.
 * Use `create(DeviceSensorSchema)` to create a new message.
 */
export const DeviceSensorSchema: GenMessage<DeviceSensor> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 1);

/**
 * DeviceDriver message represents the specific details of a driver device.
 *
 * @generated from message gateway.v1.DeviceDriver
 */
export type DeviceDriver = Message<"gateway.v1.DeviceDriver"> & {
  /**
   * model of the driver
   *
   * @generated from field: gateway.v1.DeviceDriverType model = 1;
   */
  model: DeviceDriverType;
};

/**
 * Describes the message gateway.v1.DeviceDriver.
 * Use `create(DeviceDriverSchema)` to create a new message.
 */
export const DeviceDriverSchema: GenMessage<DeviceDriver> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 2);

/**
 * CreateDeviceRequest is the request message for creating a new device.
 *
 * @generated from message gateway.v1.CreateDeviceRequest
 */
export type CreateDeviceRequest = Message<"gateway.v1.CreateDeviceRequest"> & {
  /**
   * name is the unique name of the device to be created, which can be used to identify the device in a human-readable way.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * type of the device, which indicates whether the device is a sensor or a driver.
   *
   * @generated from field: gateway.v1.DeviceType type = 2;
   */
  type: DeviceType;

  /**
   * model of the device, which can be either a sensor model or a driver model depending on the device type.
   *
   * @generated from oneof gateway.v1.CreateDeviceRequest.device
   */
  device: {
    /**
     * sensor contains the specific details of a sensor device if the device type is sensor.
     *
     * @generated from field: gateway.v1.DeviceSensor sensor = 3;
     */
    value: DeviceSensor;
    case: "sensor";
  } | {
    /**
     * driver contains the specific details of a driver device if the device type is driver.
     *
     * @generated from field: gateway.v1.DeviceDriver driver = 4;
     */
    value: DeviceDriver;
    case: "driver";
  } | { case: undefined; value?: undefined };

  /**
   * tenant_uuid is the unique identifier of the tenant that owns this device, used for multi-tenancy support.
   *
   * @generated from field: string tenant_uuid = 5;
   */
  tenantUuid: string;
};

/**
 * Describes the message gateway.v1.CreateDeviceRequest.
 * Use `create(CreateDeviceRequestSchema)` to create a new message.
 */
export const CreateDeviceRequestSchema: GenMessage<CreateDeviceRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 3);

/**
 * CreateDeviceResponse is the response message for the CreateDevice RPC, containing the details of the newly created device.
 *
 * @generated from message gateway.v1.CreateDeviceResponse
 */
export type CreateDeviceResponse = Message<"gateway.v1.CreateDeviceResponse"> & {
  /**
   * device is the newly created device.
   *
   * @generated from field: gateway.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message gateway.v1.CreateDeviceResponse.
 * Use `create(CreateDeviceResponseSchema)` to create a new message.
 */
export const CreateDeviceResponseSchema: GenMessage<CreateDeviceResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 4);

/**
 * GetDeviceByUuidRequest is the request message for retrieving a device by its UUID.
 *
 * @generated from message gateway.v1.GetDeviceByUuidRequest
 */
export type GetDeviceByUuidRequest = Message<"gateway.v1.GetDeviceByUuidRequest"> & {
  /**
   * uuid is the unique identifier of the device to retrieve.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.GetDeviceByUuidRequest.
 * Use `create(GetDeviceByUuidRequestSchema)` to create a new message.
 */
export const GetDeviceByUuidRequestSchema: GenMessage<GetDeviceByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 5);

/**
 * GetDeviceByUuidResponse is the response message for the GetDeviceByUuid RPC.
 *
 * @generated from message gateway.v1.GetDeviceByUuidResponse
 */
export type GetDeviceByUuidResponse = Message<"gateway.v1.GetDeviceByUuidResponse"> & {
  /**
   * device is the device retrieved based on the provided UUID.
   *
   * @generated from field: gateway.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceByUuidResponse.
 * Use `create(GetDeviceByUuidResponseSchema)` to create a new message.
 */
export const GetDeviceByUuidResponseSchema: GenMessage<GetDeviceByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 6);

/**
 * GetDevicesByNameRequest is the request message for searching devices by name.
 *
 * @generated from message gateway.v1.GetDevicesByNameRequest
 */
export type GetDevicesByNameRequest = Message<"gateway.v1.GetDevicesByNameRequest"> & {
  /**
   * name is the search term matched against device names.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * pagination contains the pagination parameters for retrieving a specific page of matching devices.
   *
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetDevicesByNameRequest.
 * Use `create(GetDevicesByNameRequestSchema)` to create a new message.
 */
export const GetDevicesByNameRequestSchema: GenMessage<GetDevicesByNameRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 7);

/**
 * GetDevicesByNameResponse is the response message for the GetDevicesByName RPC.
 *
 * @generated from message gateway.v1.GetDevicesByNameResponse
 */
export type GetDevicesByNameResponse = Message<"gateway.v1.GetDevicesByNameResponse"> & {
  /**
   * devices is the list of devices whose name matches the provided search term for the requested page.
   *
   * @generated from field: repeated gateway.v1.Device devices = 1;
   */
  devices: Device[];

  /**
   * metadata contains additional information about the pagination, such as total count of matching devices and the pagination parameters used.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetDevicesByNameResponse.
 * Use `create(GetDevicesByNameResponseSchema)` to create a new message.
 */
export const GetDevicesByNameResponseSchema: GenMessage<GetDevicesByNameResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 8);

/**
 * GetDeviceListByPageRequest is the request message for retrieving a paginated list of devices.
 *
 * @generated from message gateway.v1.GetDeviceListByPageRequest
 */
export type GetDeviceListByPageRequest = Message<"gateway.v1.GetDeviceListByPageRequest"> & {
  /**
   * pagination contains the pagination parameters for retrieving a specific page of devices.
   *
   * @generated from field: gateway.v1.Pagination pagination = 1;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceListByPageRequest.
 * Use `create(GetDeviceListByPageRequestSchema)` to create a new message.
 */
export const GetDeviceListByPageRequestSchema: GenMessage<GetDeviceListByPageRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 9);

/**
 * GetDeviceListByPageResponse is the response message for the GetDeviceListByPage. It contains a list of devices for the requested page.
 *
 * @generated from message gateway.v1.GetDeviceListByPageResponse
 */
export type GetDeviceListByPageResponse = Message<"gateway.v1.GetDeviceListByPageResponse"> & {
  /**
   * devices is the list of devices retrieved for the requested page based on the pagination parameters provided in the request.
   *
   * @generated from field: repeated gateway.v1.Device devices = 1;
   */
  devices: Device[];

  /**
   * metadata contains additional information about the pagination, such as total count of devices and the pagination parameters used.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceListByPageResponse.
 * Use `create(GetDeviceListByPageResponseSchema)` to create a new message.
 */
export const GetDeviceListByPageResponseSchema: GenMessage<GetDeviceListByPageResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 10);

/**
 * GetDeviceListByInstallationUuidRequest is the request message for retrieving a list of devices associated with a specific installation UUID.
 *
 * @generated from message gateway.v1.GetDeviceListByInstallationUuidRequest
 */
export type GetDeviceListByInstallationUuidRequest = Message<"gateway.v1.GetDeviceListByInstallationUuidRequest"> & {
  /**
   * installation_uuid is the unique identifier of the installation to retrieve devices for.
   *
   * @generated from field: string installation_uuid = 1;
   */
  installationUuid: string;
};

/**
 * Describes the message gateway.v1.GetDeviceListByInstallationUuidRequest.
 * Use `create(GetDeviceListByInstallationUuidRequestSchema)` to create a new message.
 */
export const GetDeviceListByInstallationUuidRequestSchema: GenMessage<GetDeviceListByInstallationUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 11);

/**
 * GetDeviceListByInstallationUuidResponse is the response message for the GetDeviceListByInstallationUuid. It contains a list of devices associated with the specified installation UUID.
 *
 * @generated from message gateway.v1.GetDeviceListByInstallationUuidResponse
 */
export type GetDeviceListByInstallationUuidResponse = Message<"gateway.v1.GetDeviceListByInstallationUuidResponse"> & {
  /**
   * devices is the list of devices associated with the specified installation UUID.
   *
   * @generated from field: repeated gateway.v1.Device devices = 1;
   */
  devices: Device[];
};

/**
 * Describes the message gateway.v1.GetDeviceListByInstallationUuidResponse.
 * Use `create(GetDeviceListByInstallationUuidResponseSchema)` to create a new message.
 */
export const GetDeviceListByInstallationUuidResponseSchema: GenMessage<GetDeviceListByInstallationUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 12);

/**
 * UpdateDeviceRequest is the request message for updating an existing device. It contains the updated details of the device, including its UUID to identify which device to update.
 *
 * @generated from message gateway.v1.UpdateDeviceRequest
 */
export type UpdateDeviceRequest = Message<"gateway.v1.UpdateDeviceRequest"> & {
  /**
   * UUID of the device to update
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the new unique name for the device. If provided, it will update the
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * type of the device, which indicates whether the device is a sensor or a driver.
   *
   * @generated from field: gateway.v1.DeviceType type = 3;
   */
  type: DeviceType;

  /**
   * model of the device, which can be either a sensor model or a driver model depending
   * on the device type. If provided, it will update the specific details of the device based on its type.
   *
   * @generated from oneof gateway.v1.UpdateDeviceRequest.device
   */
  device: {
    /**
     * sensor contains the specific details of a sensor device if the device type is sensor.
     *
     * @generated from field: gateway.v1.DeviceSensor sensor = 4;
     */
    value: DeviceSensor;
    case: "sensor";
  } | {
    /**
     * driver contains the specific details of a driver device if the device type is driver.
     *
     * @generated from field: gateway.v1.DeviceDriver driver = 5;
     */
    value: DeviceDriver;
    case: "driver";
  } | { case: undefined; value?: undefined };

  /**
   * tenant_uuid is the unique identifier of the tenant that owns this device.
   *
   * @generated from field: string tenant_uuid = 6;
   */
  tenantUuid: string;
};

/**
 * Describes the message gateway.v1.UpdateDeviceRequest.
 * Use `create(UpdateDeviceRequestSchema)` to create a new message.
 */
export const UpdateDeviceRequestSchema: GenMessage<UpdateDeviceRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 13);

/**
 * UpdateDeviceResponse is the response message for the UpdateDevice RPC, containing the details of the updated device.
 *
 * @generated from message gateway.v1.UpdateDeviceResponse
 */
export type UpdateDeviceResponse = Message<"gateway.v1.UpdateDeviceResponse"> & {
  /**
   * device is the updated device after applying the changes specified in the UpdateDeviceRequest.
   *
   * @generated from field: gateway.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message gateway.v1.UpdateDeviceResponse.
 * Use `create(UpdateDeviceResponseSchema)` to create a new message.
 */
export const UpdateDeviceResponseSchema: GenMessage<UpdateDeviceResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 14);

/**
 * DeleteDeviceRequest is the request message for deleting a device based on its UUID.
 *
 * @generated from message gateway.v1.DeleteDeviceRequest
 */
export type DeleteDeviceRequest = Message<"gateway.v1.DeleteDeviceRequest"> & {
  /**
   * uuid is the unique identifier of the device to delete.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.DeleteDeviceRequest.
 * Use `create(DeleteDeviceRequestSchema)` to create a new message.
 */
export const DeleteDeviceRequestSchema: GenMessage<DeleteDeviceRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 15);

/**
 * DeleteDeviceResponse is the response message for the DeleteDevice RPC, indicating whether the deletion was successful.
 *
 * @generated from message gateway.v1.DeleteDeviceResponse
 */
export type DeleteDeviceResponse = Message<"gateway.v1.DeleteDeviceResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteDeviceResponse.
 * Use `create(DeleteDeviceResponseSchema)` to create a new message.
 */
export const DeleteDeviceResponseSchema: GenMessage<DeleteDeviceResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device, 16);

/**
 * Device types
 *
 * @generated from enum gateway.v1.DeviceType
 */
export enum DeviceType {
  /**
   * Unspecified device type, used as a default value.
   *
   * @generated from enum value: DEVICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sensor device type, representing devices that collect data from the environment.
   *
   * @generated from enum value: DEVICE_TYPE_SENSOR = 1;
   */
  SENSOR = 1,

  /**
   * Driver device type, representing devices that connects to cloud and sends data.
   *
   * @generated from enum value: DEVICE_TYPE_DRIVER = 2;
   */
  DRIVER = 2,
}

/**
 * Describes the enum gateway.v1.DeviceType.
 */
export const DeviceTypeSchema: GenEnum<DeviceType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_device, 0);

/**
 * Device sensor model type
 *
 * @generated from enum gateway.v1.DeviceSensorType
 */
export enum DeviceSensorType {
  /**
   * Unspecified sensor type, used as a default value.
   *
   * @generated from enum value: DEVICE_SENSOR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Ultrasonic sensor type
   *
   * @generated from enum value: DEVICE_SENSOR_TYPE_ULTRASONIC = 1;
   */
  ULTRASONIC = 1,
}

/**
 * Describes the enum gateway.v1.DeviceSensorType.
 */
export const DeviceSensorTypeSchema: GenEnum<DeviceSensorType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_device, 1);

/**
 * Device sensor model for ultrasonic sensors
 *
 * @generated from enum gateway.v1.DeviceSensorUltrasonicModel
 */
export enum DeviceSensorUltrasonicModel {
  /**
   * Unspecified ultrasonic sensor model, used as a default value.
   *
   * @generated from enum value: DEVICE_SENSOR_ULTRASONIC_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * US100 ultrasonic sensor model, a common model used for distance measurement.
   *
   * @generated from enum value: DEVICE_SENSOR_ULTRASONIC_MODEL_US100 = 1;
   */
  US100 = 1,
}

/**
 * Describes the enum gateway.v1.DeviceSensorUltrasonicModel.
 */
export const DeviceSensorUltrasonicModelSchema: GenEnum<DeviceSensorUltrasonicModel> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_device, 2);

/**
 * @generated from enum gateway.v1.DeviceSensorSewerLocation
 */
export enum DeviceSensorSewerLocation {
  /**
   * Unspecified sensor location, used as a default value.
   *
   * @generated from enum value: DEVICE_SENSOR_SEWER_LOCATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Public sewer location, indicating that the sensor is placed in a public sewer.
   *
   * @generated from enum value: DEVICE_SENSOR_SEWER_LOCATION_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * Private sewer location, indicating that the sensor is placed in a private sewer.
   *
   * @generated from enum value: DEVICE_SENSOR_SEWER_LOCATION_PRIVATE = 2;
   */
  PRIVATE = 2,
}

/**
 * Describes the enum gateway.v1.DeviceSensorSewerLocation.
 */
export const DeviceSensorSewerLocationSchema: GenEnum<DeviceSensorSewerLocation> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_device, 3);

/**
 * Device driver type
 *
 * @generated from enum gateway.v1.DeviceDriverType
 */
export enum DeviceDriverType {
  /**
   * Unspecified driver type, used as a default value.
   *
   * @generated from enum value: DEVICE_DRIVER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Cactus SeedPro board. Used as initial driver model for testing and development, will be replaced with actual driver models in the future.
   *
   * @generated from enum value: DEVICE_DRIVER_TYPE_DRIVER_PRO_V1 = 1;
   */
  DRIVER_PRO_V1 = 1,
}

/**
 * Describes the enum gateway.v1.DeviceDriverType.
 */
export const DeviceDriverTypeSchema: GenEnum<DeviceDriverType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_device, 4);

/**
 * DeviceService defines the gRPC service for managing devices.
 *
 * -------------------------------------------------------------------------
 * Device entity CRUD operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.DeviceService
 */
export const DeviceService: GenService<{
  /**
   * CreateDevice creates a new device in the system.
   *
   * @generated from rpc gateway.v1.DeviceService.CreateDevice
   */
  createDevice: {
    methodKind: "unary";
    input: typeof CreateDeviceRequestSchema;
    output: typeof CreateDeviceResponseSchema;
  },
  /**
   * GetDeviceByUuid retrieves a device by its unique identifier (UUID).
   *
   * @generated from rpc gateway.v1.DeviceService.GetDeviceByUuid
   */
  getDeviceByUuid: {
    methodKind: "unary";
    input: typeof GetDeviceByUuidRequestSchema;
    output: typeof GetDeviceByUuidResponseSchema;
  },
  /**
   * GetDevicesByName retrieves devices whose name matches the given search term.
   *
   * @generated from rpc gateway.v1.DeviceService.GetDevicesByName
   */
  getDevicesByName: {
    methodKind: "unary";
    input: typeof GetDevicesByNameRequestSchema;
    output: typeof GetDevicesByNameResponseSchema;
  },
  /**
   * GetDeviceListByPage retrieves a paginated list of all devices.
   *
   * @generated from rpc gateway.v1.DeviceService.GetDeviceListByPage
   */
  getDeviceListByPage: {
    methodKind: "unary";
    input: typeof GetDeviceListByPageRequestSchema;
    output: typeof GetDeviceListByPageResponseSchema;
  },
  /**
   * GetDeviceListByInstallationUuid retrieves a list of devices associated with a specific installation UUID.
   *
   * @generated from rpc gateway.v1.DeviceService.GetDeviceListByInstallationUuid
   */
  getDeviceListByInstallationUuid: {
    methodKind: "unary";
    input: typeof GetDeviceListByInstallationUuidRequestSchema;
    output: typeof GetDeviceListByInstallationUuidResponseSchema;
  },
  /**
   * UpdateDevice updates the details of an existing device identified by its UUID.
   *
   * @generated from rpc gateway.v1.DeviceService.UpdateDevice
   */
  updateDevice: {
    methodKind: "unary";
    input: typeof UpdateDeviceRequestSchema;
    output: typeof UpdateDeviceResponseSchema;
  },
  /**
   * DeleteDevice removes a device from the system based on its UUID.
   *
   * @generated from rpc gateway.v1.DeviceService.DeleteDevice
   */
  deleteDevice: {
    methodKind: "unary";
    input: typeof DeleteDeviceRequestSchema;
    output: typeof DeleteDeviceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_device, 0);

